import axios from "axios";
import { baseUrl } from "./urlConfig";

class APIService {


  inputResonse = async (requestData) => {
    try {

      const url = `${baseUrl}/cbapi/chat`;

      // let config;


      // if (userDetails !== null && userDetails !== undefined) {
      // config = {
      //   params: requestData
      // };
      // }

      const config = {
        headers: { Authorization: `Bearer ${requestData?.token}` },
        params: requestData
      };
      return axios.get(url, config);
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  };

  inputSearch = async (requestData) => {
    try {
      const url = `${baseUrl}/cbapi/searchrmn`;
  
      const config = {
        headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` },
        params: { rmn: requestData }
      };
  
      return axios.post(url, {}, config); // empty body since we're using query params
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  };
  
  
  // Fetch pack details for Explore Packs tiles (A13ExplorePacksNew)
  getPackDetails = async ({ packType, sessionId, startFrom }) => {
    try {
      const params = new URLSearchParams();
      if (packType) params.append('packType', packType);
      if (sessionId) params.append('sessionId', sessionId);
      if (startFrom !== undefined && startFrom !== null) params.append('startFrom', String(startFrom));
      const url = `${baseUrl}/cbapi/getpackdetails?${params.toString()}`;
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      console.error('Error in getPackDetails:', error);
      throw error;
    }
  };

  // Send selected add/drop packs back to chat API (A15 actions)
  sendPackSelection = async ({ addPack = [], dropPack = [], sessionId, infoText, code }) => {
    try {
      const payload = {
        sessionId,
        addPack,
        dropPack,
        action: infoText, // 'add' | 'drop' | 'both'
        code, // e.g. '1800.add' or '1800.add.fdo'
      };
      const response = await axios.post(`${baseUrl}/cbapi/packSelection`, payload);
      return response.data;
    } catch (error) {
      console.error('Error in sendPackSelection:', error);
      throw error;
    }
  };
  inputResonsePostPacks = (params, input) => {
    const url = `${baseUrl}/cbapi/chat`;
    const bearerToken = localStorage.getItem("token");
    // console.log("beareretoken", bearerToken);


    const config = {
      headers: { Authorization: `Bearer ${params?.token}` },
      params: params,
      // input:input
    };
    return axios.post(url, input, config);
  };

  sendMail = async (sessionId) => {
    try {

      const url = `${baseUrl}/cbapi/bSendMail?bot=agent-assist&sessionId=${sessionId}`;

      // let config;
      // if (userDetails !== null && userDetails !== undefined) {
      // config = {
      //   params: requestData
      // };
      // }
      const token = sessionStorage.getItem("token")
      const config = {
        headers: { Authorization: `Bearer ${token}` },
        // params: requestData
      };
      return axios.get(url, config);
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  };

  // inputPostResonse = (data, input,token) => {
  //   const url = `${baseUrl}/cbapi/chat`;
  //   const bearerToken = token || sessionStorage.getItem("token");
  //   // console.log("beareretoken", bearerToken);
  //   const params = input
  //     ? { bot: "agent-assist", code: data }
  //     : { bot: "agent-assist", code: data };
  //   //  console.log(input,params,"HEREEEEE");

  //   // params.input = encodeURIComponent(JSON.stringify(input));
  //   // input = encodeURIComponent(JSON.stringify(input));

  //   const config = {
  //     headers: { Authorization: `Bearer ${bearerToken}` },
  //     params: params,
  //     // input:input
  //   };
  //   // console.log("api-chat", "code-chat:", data);
  //   // console.log(config, "params", params);
  //   return axios.post(url, input, config);
  // };
  
  inputPostResonse = (data, input, token) => {
    const url = `${baseUrl}/cbapi/chat`;
    const bearerToken = token || sessionStorage.getItem("token");

    const params = { bot: "agent-assist", code: data };

    const formattedInput = typeof input === "object" ? JSON.stringify(input) : input;

    const config = {
      headers: { Authorization: `Bearer ${bearerToken}` },
      params: params,
    };

    console.log("Formatted Input:", formattedInput);
    console.log("API Params:", params);
    console.log("API Config:", config);
    return axios.post(url, formattedInput, config);
  };


  regenrate = async (requestData) => {
    try {
      const response = await fetch("https://e016-108-21-87-23.ngrok-free.app/regenerate", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(requestData),

      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const result = await response.text();
      return result;
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  }

  feedbackApi = async (requestData) => {
    try {


      const url = `${baseUrl}/agentFeedback`;

      const response = await fetch(`${baseUrl}/agentFeedback`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(requestData),

      });

      // if (!response.ok) {
      //   throw new Error("Network response was not ok");
      // }

      // const result = await response.text();
      // return result;
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  }

  loginForLinkk = async (userDetails) => {
    // localStorage.setItem("linkLoginOnce", true);

    const url = `${baseUrl}/cbapi/login`;

    const config = userDetails ? {
      bot: "agent-assist",
      user: userDetails,

    } : {};

    const queryString = new URLSearchParams(config).toString();
    const fullUrl = `${url}?${config}`;

    try {
      const response = await fetch(fullUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        }
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  }; 
 loginSubSession = async (userDetails, agentGroup, agentType, agentName, agentLogID, uniqueId, parentSessionId, ctaName) => {
    const url = `${baseUrl}/cbapi/login`;
    const config = {
      params: {
        bot: "agent-assist",
        // user: userDetails?.trim() || sessionStorage.getItem("userIdS360") ,
        user: userDetails?.trim() || localStorage.getItem("userIdS360"),
        subSession: true,
        parentId: parentSessionId,
        ctaName: ctaName,
        gethelpOs: JSON.stringify({ device: "Web" }),
        extra: JSON.stringify({
          agentGroup: agentGroup || "",
          agentType: agentType || "",
          agentName: agentName || "",
          agentLogID: agentLogID || "",
          uniqueId: uniqueId || ""
        })
      }
    };
    return axios.get(url, config);
  };

  loginForLink = async (userDetails, agentGroup, agentType, agentName, agentLogID, uniqueId) => {
    localStorage.setItem("linkLoginOnce", true);

    const url = `${baseUrl}/cbapi/login`;

    let config;
    if (userDetails !== null && userDetails !== undefined) {
      config = {
        params: {
          bot: "agent-assist",
          user: userDetails,
          gethelpOs: JSON.stringify({
            device: 'isMobile' ? "Mobile" : 'isTablet' ? "Tablet" : "Web",
            // os: osName,
            // osVersion: osVersion,
            // browser: browserName,
          }),
          extra: JSON.stringify({ agentGroup: agentGroup || '', agentType: agentType || '', agentName: agentName || '', agentLogID: agentLogID || '', uniqueId: uniqueId || '' })
        },
      };
    }
    return axios.get(url, config);
  };

  loginForRefresh = async (data) => {
    const url = `${baseUrl}/cbapi/updatesession?bot=agent-assist&action=${data}`;

    const bearerToken = sessionStorage.getItem("token");

    const config = {
      headers: { Authorization: `Bearer ${bearerToken}` },
    };

    return axios.post(url, {}, config);
  };

  fetchPreviousHistory = async ({ sessionId, month, year }) => {
    try {
      const url = `${baseUrl}/cbapi/fetchedPreviousHistory?sessionID=${sessionId}&month=${month}&year=${year}`;
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      console.error('Error in fetchPreviousHistory:', error);
      throw error;
    }
  };


}

let apiService = new APIService();
export default apiService;
